import React, { useEffect, useContext } from "react";
import Login from "./components/login/Login";
import Loader from "./reusableComponent/isLoading/Loader";

// import ComponentRoute from "./components/main/ComponentRoute";
import ComponentRoute from "./components/main/bigCommerce/ComponentRoute";
import { useNavigate, Route, Routes } from "react-router-dom";
import axios from "axios";
import { AdminDataContext } from "./useContext/AdminContext";
import SnackbarComponent from "./reusableComponent/snackbarComponent/SnackbarComponent";
import SocketNotification from "./components/SocketNotification";
import API, { setAuthToken } from "./api";
import LoginPageBigCommerce from "./components/login/LoginPageBigCommerce";
import UserErrorPage from "./components/bigCommerce/user/UserErrorPage";
const App = () => {
  const {
    isAuthenticated,
    setIsAuthenticated,
    isLoading,
    setIsLoading,
    message,
    severity,
    openSnackbar,
    setOpenSnackbar,
    updateAdminData,
  } = useContext(AdminDataContext);
  const navigate = useNavigate();
  const getAdminDataApi = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        setAuthToken(accessToken);
      }
      console.log("accessToken", accessToken);

      const res = await API.get("/api/v1/users/current-user");

      // Check if user is blocked
      if (res.data.data.user.isBlocked) {
        setIsLoading(false);
        setIsAuthenticated(false);
        navigate("/user-blocked");
        return;
      }

      setIsAuthenticated(true);
      // console.log(res.data);

      console.log(res.data.data.user);
      updateAdminData(res.data.data.user);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      navigate("/login");
    }
  };

  useEffect(() => {
    getAdminDataApi();
  }, []);

  return (
    <>
      <Loader open={isLoading} setOpen={setIsLoading} />
      <SnackbarComponent
        message={message}
        severity={severity}
        open={openSnackbar}
        setOpen={setOpenSnackbar}
      />
      {isAuthenticated ? (
        <>
          <ComponentRoute />
          {/* <ComponentRoute /> */}
          {/* <SocketNotification /> */}
        </>
      ) : (
        <Routes>
          {/* original login route */}
          {/* <Route
            path="/login"
            element={<Login setIsAuthenticated={setIsAuthenticated} />}
          /> */}
          {/* bigcommerce login route */}
          <Route
            path="/login"
            element={
              <LoginPageBigCommerce setIsAuthenticated={setIsAuthenticated} />
            }
          />
          {/* User blocked error page */}
          <Route path="/user-blocked" element={<UserErrorPage />} />
        </Routes>
      )}
    </>
  );
};

export default App;
